import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/core/assets/icons/icon-close.svg'


const _withScopeId = n => (_pushScopeId("data-v-e8808e5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-wrapper" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Confirm")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_5 = { class: "disclaimer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_default_button = _resolveComponent("default-button")!
  const _component_modal_backdrop = _resolveComponent("modal-backdrop")!

  return (_openBlock(), _createBlock(_component_modal_backdrop, { class: "modal-backdrop" }, {
    default: _withCtx(() => [
      _createElementVNode("section", {
        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("img", {
          src: _imports_0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
          alt: "close",
          class: "close"
        }),
        _createElementVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "header", {}, undefined, true)
        ]),
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "content", {}, undefined, true),
          _createVNode(_component_default_button, {
            class: "primary-button",
            disabled: _ctx.disabled,
            onActivate: _ctx.confirm,
            style: _normalizeStyle({backgroundColor: _ctx.mainButtonColor})
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "button-content", {}, () => [
                _hoisted_3
              ], true)
            ]),
            _: 3
          }, 8, ["disabled", "onActivate", "style"]),
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.secondaryAction && _ctx.secondaryAction(...args))),
            class: "secondary"
          }, [
            _renderSlot(_ctx.$slots, "secondary-action", {}, undefined, true)
          ]),
          (_ctx.hasCancel)
            ? (_openBlock(), _createBlock(_component_default_button, {
                key: 0,
                onActivate: _ctx.close,
                class: "cancel"
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onActivate"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "disclaimer", {}, undefined, true)
        ])
      ])
    ]),
    _: 3
  }))
}